import { CONFIG_LOCAL_STORAGE } from './../constants/Define';

const getStorageKey = (key) => `${CONFIG_LOCAL_STORAGE.PREFIX}_${key}`;
const getEnvironmentStorageKey = (key) => `${CONFIG_LOCAL_STORAGE.PREFIX}_${process.env.REACT_APP_ENVIRONMENT}_${key}`;

export const get = (key) => {
    const storageKey = getStorageKey(key);
    const stringData = localStorage.getItem(storageKey);
    // const stringData = sessionStorage.getItem(storageKey);
    const numberRegex = RegExp('^[1-9.]+$');
    if(stringData === 'true' || stringData === 'false'){
        return stringData === 'true'
    } else if(stringData === 'null'){
        return null;
    } else if(stringData === 'undefined'){
        return undefined;
    } else if(numberRegex.test(stringData)){
        return Number(stringData)
    } else {
        try {
            const data = JSON.parse(stringData);
            return data;
        } catch (error) {
            return stringData
        }
    }
}

export const set = (key, data) => {
    const storageKey = getStorageKey(key);
    let stringData = undefined;
    try {
        if(typeof data === 'object'){
            stringData = JSON.stringify(data)
        } else {
            stringData = String(data);
        }
    } catch (error) {
        stringData = data
    }
    // return sessionStorage.setItem(storageKey, stringData);
    return localStorage.setItem(storageKey, stringData);
}

export const remove = (key) => {
    localStorage.removeItem(getStorageKey(key));
    localStorage.removeItem(getEnvironmentStorageKey(key));
}

export default {
    get,
    set,
    remove,
};
